











































































import Vue, { PropType } from 'vue';
import { shortTimeAgo } from '@/helpers/date-utils';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { DISCOUNT_TYPE, OFFER_TYPE } from '@/store/shared';
import { ISession } from '@/store/types';

export default Vue.extend({
  name: 'SessionFeedbackTooltip',
  mixins: [CopyToClipboard],
  props: {
    session: {
      type: Object as PropType<ISession>,
    },
    confidential: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      DISCOUNT_TYPE,
      shortTimeAgo,
    };
  },
  methods: {
    view(session: ISession) {
      this.$emit('view', session);
    },
  },
});
